<template>
  <layout-default-app-bar :back-to="backTo">
    Ordem - {{$$_ordem.orcidordemcarregamento}}
  </layout-default-app-bar>
</template>

<script>

// import { IMAGENS_QUERIES } from '@/constants/QUERY_FILTERS';

import {
  ROUTE_ORDEM_CARREGAMENTO
} from '@/constants/ROUTES';

import LayoutDefaultAppBar from '@/layouts/default/AppBar.vue';
import { mapState } from 'vuex';

export default {
  name: 'ViewHomeAppBar',

  components: {
    LayoutDefaultAppBar,
  },

  computed: {
    ...mapState({
      $$_ordem: (state) => state.ordemcarregamento.ordem,
    })
  },

  data() {
    return {
      backTo: ROUTE_ORDEM_CARREGAMENTO
    };
  },

};
</script>

<style scoped>
  #icone{
    top: 6%;
    position: relative;
  }

  #texto {
    position: absolute;
    left: 120px;
    bottom: 8px;
    font-size: 24px;
  }
</style>
